import {
  Box,
  Button,
  Card,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import MilitaryTechIcon from "@mui/icons-material/MilitaryTech";
import { useNavigate } from "react-router-dom";

import { formatProfile } from "@/formatter";
import trainerDefaultImage from "/assets/trainer-default-image.svg";
import { theme } from "@/theme";

import type { MouseEventHandler } from "react";
import type { Trainer } from "@/models";

type PTCardProps = {
  data: Trainer;
  branchId: number;
};

export function TrainerCard({ data, branchId }: PTCardProps) {
  const {
    id,
    trainerProfileData: { avatarUrl, skills },
    profile,
  } = data;
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const onClick: MouseEventHandler<HTMLButtonElement> = () => {
    navigate(`${id.toString()}?branchId=${branchId}`);
  };

  const buttonSize = isMobile ? "small" : "medium";

  return (
    <Card sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Box
        width="100%"
        pt="150%"
        sx={{
          backgroundImage: `url(${avatarUrl ?? trainerDefaultImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <Stack px={2} pt={2}>
        <Typography
          gutterBottom
          sx={{
            typography: { xs: "subtitle2", sm: "h6" },
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
            width: "100%",
          }}
        >
          {formatProfile(profile, true)}
        </Typography>
        {skills.length > 0 ? (
          <Stack direction="row" mt={1} gap={0.5}>
            <MilitaryTechIcon sx={{ color: "text.secondary" }} />
            <Stack gap={0.5}>
              {skills.map((skill) => (
                <Typography
                  key={skill}
                  color="text.secondary"
                  typography={{ xs: "caption", sm: "body2" }}
                >
                  {skill}
                </Typography>
              ))}
            </Stack>
          </Stack>
        ) : (
          <></>
        )}
      </Stack>
      <Box mt="auto" p={2}>
        <Button
          size={buttonSize}
          variant="contained"
          fullWidth
          onClick={onClick}
        >
          รายละเอียด
        </Button>
      </Box>
    </Card>
  );
}
